var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',{attrs:{"options":_vm.taxes,"multiple":_vm.multiple,"value":_vm.value,"track-by":"id","label":"name","placeholder":_vm.placeholder,"loading":_vm.onLoading('fetch-tax')},on:{"select":_vm.onSelect}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3007bb82","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/pug-deps-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/selector/tax-selector.vue
// module id = oTGk
// module chunks = 99